import React from 'react';

export default function IconLoader({ size = 100, color = 'currentColor' }) {
  return (
    <svg
      id="logo"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      viewBox="0 0 100 100"
      width={size} // use prop
      height={size} // use prop
      stroke={color} // applies to elements using currentColor
      fill={color} // applies to circle
      aria-label="Logo">
      <title>Logo</title>

      <defs>
        <linearGradient id="accent" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="var(--green, #2dd4bf)" />
          <stop offset="100%" stopColor="var(--blue, #3b82f6)" />
        </linearGradient>
      </defs>

      <style>{`
        #logo .border {
          fill: none;
          stroke: currentColor;
          stroke-width: 5;
          stroke-linejoin: round;
          stroke-linecap: round;

          /* total perimeter of rounded rect ≈ 336 */
          stroke-dasharray: 336;
          stroke-dashoffset: 336;
          animation: drawBorder 2s ease-out forwards;
        }

        @keyframes drawBorder {
          to { stroke-dashoffset: 0; }
        }
      `}</style>

      <g>
        {/* Animated outer rounded rectangle */}
        <rect className="border" x="8" y="8" width="84" height="84" rx="18" ry="18" />

        {/* Inner accent path */}
        <path
          d="M35 65 C35 52 65 52 65 40 C65 32 58 28 50 28 C42 28 36 32 34 39"
          fill="none"
          stroke="url(#accent)"
          strokeWidth="6"
          strokeLinecap="round"
        />
        <circle cx="50" cy="68" r="3" fill="currentColor" />
      </g>
    </svg>
  );
}
